(function(){
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    // 2 sliders control ----------------------------------------------------------------

    let swiper = new Swiper(".mySwiper", {
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
            return '<span class="' + className + ' bullet bullet-'+ index +'">' + (index + 1) + "</span>";
            },
        },
    });

    let main_swiper = new Swiper(".swiperGallery", {
        rewind:true,
        speed: 900,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        }
    });

    let other_swiper = new Swiper(".swiperControlled", {
        rewind:true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }

    })
    let other_swiper_2 = new Swiper(".swiperControlled_2", {
        rewind:true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    })

    main_swiper.controller.control = [other_swiper, other_swiper_2];
    other_swiper.controller.control = main_swiper;
    other_swiper_2.controller.control = main_swiper;

    // Progress bar functionality ----------------------------------------------------------------------------
    let swiperBar = new Swiper(".swiper-progress-bar", {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination"
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        on: {
            init: function () {
                startProgressbar();
            },
            slideChange: function () {
                resetProgressbar();
                progressBarIndex = this.activeIndex;
                startProgressbar();
            },
        }
    });
    
    let percentTime;
    let tick;
    let time = (swiperBar.params.autoplay.delay - 100) / 1000; 
    let progressBarIndex = 0;
    
    $('.progressBarContainer .progressBar').each(function (index) {
        var progress = "<div class='inProgress inProgress" + index + "'></div>";
        $(this).html(progress);
    });
    
    startProgressbar();
    
    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        tick = setInterval(interval, 10);
    }
    
    function interval() {
        percentTime += 1 / (time + 5);
        $('.inProgress').css({
            width: percentTime + "%"
        });
        if (percentTime >= 100) {
            swiperBar.slideNext();
            progressBarIndex++;
            if (progressBarIndex > 2) {
                progressBarIndex = 0;
            }
            startProgressbar();
        }
    }
    
    function resetProgressbar() {
        $('.inProgress').css({
            width: 0 + '%'
        });
        clearInterval(tick);
    }
    
    

})();


